export interface HoleChallengeStatus {
    challenge: { name: string; hole: number; [key: string]: any } | null;
    hasSubmission: boolean;
}

/**
 * Returns the challenge configured for a hole (if any) and whether the marker
 * has at least one challengeSubmission for that challenge name + hole.
 */
export function holeChallengeStatus(
    eventData: any,
    scoreData: any[],
    scoreCode: string,
    currentRound: number,
    hole: number,
): HoleChallengeStatus {
    const activeRound = eventData?.rounds?.find((r: any) => r.roundNumber === currentRound);
    const challenge = activeRound?.challenges?.find((c: any) => c.hole === hole) ?? null;

    if (!challenge) {
        return { challenge: null, hasSubmission: false };
    }

    const markerScore = scoreData.find(
        (score: any) => score.roundScores?.[currentRound - 1]?.markerScoreCode === scoreCode,
    );
    const submissions =
        markerScore?.roundScores?.[currentRound - 1]?.challengeSubmissions ?? [];

    const hasSubmission = submissions.some(
        (s: any) => s.challengeName === challenge.name && s.challengeHole === challenge.hole,
    );

    return { challenge, hasSubmission };
}
